module.exports = __webpack_public_path__ + "4322558f228b598090042b0459a1e08b.svg";